import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Sheet from "react-modal-sheet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import ArrowLeft from "../../assets/images/Arrow-left.svg";
import dropdown1 from "../../assets/images/dropdown.svg";
import home from "../../assets/images/HomeDisable.svg";
import idea from "../../assets/images/idea1.svg";
import left from "../../assets/images/left.svg";
import Backicon from "../../assets/images/mobback.svg";
import rightArr from "../../assets/images/navRight.svg";
import { Grid, Typography } from "@material-ui/core";
import One from "../../assets/images/one.svg";
import ficon from "../../assets/images/popularS.svg";
import right from "../../assets/images/right.svg";
import Search from "../../assets/images/search.svg";
import Stepone from "../../assets/images/stepone.svg";
import Steptwo from "../../assets/images/steptwo.svg";
import Three from "../../assets/images/three.svg";
import Two from "../../assets/images/two.svg";
import {
  Card,
  CardSelectedTest,
  CardSelectTest,
  Filter,
  MobileCardSelectedTest,
  Popup,
  SliderComponent,
  Toast,
} from "../../components";
import axios from "axios";
import Chat from "../../components/Chat/Chat";
import LoaderComponent from "../../components/Loading/LoaderComponent";
import { AlphabeticalFilter } from "../../components";
import PackageCard from "./components/PacakgeCard";
import Layout from "../../layout";
import PartnerSlider from "../Landing/PartnerSlider";
import { getLabPackages } from "../../redux/labpackage/labpackageActions";
import "./styles.scss";

const PopularPackages = (props) => {
  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  const focusPoint = useRef(null);
  const [ShowLocation, setShowLocation] = useState(false);
  const [selectedRec, setSelectedRec] = useState([]);
  const [ShowArea, setShowArea] = useState(false);
  const [inputSearch, setInputSearch] = useState("");
  const [filterby, setFilterby] = useState("all");

  const [btn, setBtn] = useState(false);
  const [btmLocationSheet, setbtmLocationSheet] = useState(false);
  const [city, setCity] = useState([]);
  const [packagesCount, setPackagesCount] = useState(0);
  console.log(packagesCount, "packagesCount")
  const [pageno, setPageno] = useState(1);
  const [packages, setPackages] = useState([]);
  const [partner, setPartner] = useState([]);
  const [area, setArea] = useState("");
  const [mobileView, setMobileView] = useState(false);
  const [mobileTestpopstate, setMobiletestpopstate] = useState(false);
  const [popularTest, setPopularTest] = useState([]);
  const dispatch = useDispatch();
  const sheetRef = useRef();

  const cityState = useSelector((state) =>
    state.city !== undefined && state.city.label !== undefined ? state.city : ""
  );

  const areaState = useSelector((state) =>
    state.area !== undefined && state.area.area !== undefined
      ? state.area.area
      : ""
  );

  const _labPackages = useSelector((state) => state.labPackageReducer);

  React.useEffect(() => {
    if (_labPackages && _labPackages.labPackageData.data) {
      setPackagesCount(_labPackages.labPackageData.count);
      var _packages = _labPackages.labPackageData.data;
      setPackages(_packages);
    }
    window.scrollTo(0, 600);

  }, [_labPackages]);

  React.useEffect(() => {
    if (_labPackages && _labPackages.labPackageData.data) {
      setPackagesCount(_labPackages.labPackageData.count);
      var _packages = _labPackages.labPackageData.data.slice(
        pageno * 8 - 8,
        pageno * 8
      );
      setPackages(_packages);
    }
    window.scrollTo(0, 600);

  }, [pageno]);

  const [btmSheet, setbtmSheet] = useState(false);
  const globalSearch = useSelector((state) => state.auth.search);
  const [searchData, setSearchData] = useState([]);

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const test = useSelector((state) => state);

  const history = useHistory();

  const lanTestes = history.location.state;

  const handleCount1 = (v) => {
    if (pageno + v > 0 && pageno + v <= Math.ceil(packagesCount / 8)) {
      dispatch(getLabPackages(pageno + v, inputSearch, filterby, 9));
      setPageno(pageno + v);
      getLabPackages(pageno + v, inputSearch, filterby, 9);
      window.scrollTo(0, 600);
    } else if (pageno + v > Math.ceil(packagesCount / 8)) {
      setPageno(Math.ceil(packagesCount / 8));
      window.scrollTo(0, 600);
      // getLabPackages(pageno)
    } else {
      setPageno(0);
      window.scrollTo(0, 600);
      // getLabPackages(0)
    }
  };

  const [category, setCategory] = useState('Select Category')
  const [categoryli, setCategorylist] = useState([])
  const [diseaseli, setdiseaselist] = useState([])


  const Categorylist = []
  const diseaselist = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/doctallnew/listcategorydisease`)
      .then((res) => {
        console.log(res.data, "res")
        setCategorylist(res.data)
        setFilterby("all")
        return res.data.map((item) => {
          return Categorylist.push({ uuid: item.uuid, name: item.name })
        })
      })
      .catch((err) => {
        console.log(err, "err")
      })
  }
  console.log(Categorylist, "res")

  const diseaseList = []
  const categoryChange = (uuid) => {

    setCategory(uuid)
    categoryli.map((dat) => {
      if (dat.uuid === uuid) {
        setdiseaselist(dat.diseases)

        dat.diseases.map((item) => {
          diseaseList.push({ uuid: item.uuid, name: item.name })
        })
      }
    })
  }

  useEffect(() => {
    diseaselist()
  }, [])

  useEffect(() => {
    setPageno(0)
    dispatch(getLabPackages(0, inputSearch, filterby, 9));

  }, [inputSearch, filterby])

  return (
    <div>
      <Layout>
        <div className="popularContainer">
          {!mobileView ? (
            <>
              <div className="title">
                <img
                  src={home}
                  alt="icon"
                  onClick={() => {
                    history.push("/");
                  }}
                />
                <img src={rightArr} alt="icon" />
                Diagnostic Packages
              </div>{" "}
              <div className="steps_to_follow">
                <div className="header">Steps to Follow</div>
                <div className="pt_card_container">
                  <div className="card_container">
                    <img src={One} alt="icon" />
                    Search for your package
                  </div>
                  <div className="card_container">
                    <img src={Two} alt="icon" />
                    Select your location
                  </div>
                  <div className="card_container">
                    <img src={Three} alt="icon" />
                    Compare prices and buy
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="mobile-view-popular-outer-cls">
              <div
                className="header-back-row"
                onClick={() => {
                  history.goBack();
                }}
              >
                <img src={Backicon} alt="Backicon" />
                <div className="back-text">Back</div>
              </div>
              <div className="steps-container-out">
                <div className="head-font">Steps to Follow</div>
                <div className="step-one-cls">
                  <img src={Stepone} alt="Stepone" />
                  <div className="right-cls">
                    <span>Search for your package.</span>
                    <br /> You can locate your desires package using the
                    alphabetical filter
                  </div>
                </div>
                <div className="step-two-cls">
                  <img src={Steptwo} alt="Stepone" />
                  <div className="right-cls">Select package and buy</div>
                </div>
              </div>
            </div>
          )}

          <div className="page_container">
            <div className="btn-wrap">
              {/* <div
                className={btn ? "btn btnNoAction" : "btn btnAction"}
                onClick={() => {
                  setBtn(!btn);
                  // setFilterValue("all");
                }}
              >
                All
              </div> */}
            </div>
            <div className="item_container">
              <div className="input_Container">
                <img src={Search} alt="icon" />
                <input
                  type="text"
                  className="input_search"
                  placeholder="Search packages"
                  value={inputSearch}
                  onChange={(e) => setInputSearch(e.target.value)}
                />
              </div>
              <div className="tips_container">
                <div className="heading_container">
                  <img src={idea} alt="icon" />
                  <div className="heading">Help Tip</div>
                </div>
                <div className="txt">
                  Use the search bar to find the package you want.
                </div>
              </div>
            </div>

            {/* Popular Test Section */}
            <div style={{ display: "flex", alignItems: "start", paddingLeft: "4%" }}>
              <div className="txt">&nbsp;&nbsp;&nbsp;
                <select style={{ height: "6vh", width: "auto", borderRadius: "10px", backgroundColor: "#f7f8fb", border: "1px solid #e3eaf6" }} value={category} onChange={(event) => categoryChange(event.target.value)}>
                  <option value="all">---Select---</option>
                  {categoryli && categoryli.map((catlist) => {
                    return <option value={catlist.uuid}>{catlist.name}</option>
                  })}

                </select>
              </div>&nbsp;&nbsp;&nbsp;
              <div className="txt">
                <select style={{ height: "6vh", width: "auto", borderRadius: "10px", backgroundColor: "#f7f8fb", border: "1px solid #e3eaf6" }} value={filterby} onChange={(event) => setFilterby(event.target.value)}>
                  <option value="all">---Select---</option>
                  {diseaseli && diseaseli.map((li) => {
                    return <option value={li.uuid}>{li.name}</option>
                  })}

                </select>
              </div>
            </div>
            <div className="input_containerrr">
              <div className="leftContainer">
                <div className="heading_container">
                  <div className="heading">MOST POPULAR PACKAGES</div>
                  {/* <div className="txt">
                    Browse through our common/popular packages
                  </div> */}



                </div>
                {/* <AlphabeticalFilter
                  onFilter={(d) => {
                    setInputSearch("");
                  }}
                /> */}
              </div>
              {!mobileView && (
                <div style={{ direction: "row" }}>
                  <div className="right_container">
                    <div>
                      <span style={{ display: "flex", justifyContent: "center", }}>Set Location</span>
                    </div>
                    <div>
                      {cityState.label !== "" && areaState.label !== "" ? (
                        <div
                          className="location"
                          onClick={() => setShowLocation(true)}
                          style={{
                            color: "#191716",
                            display: "flex",
                            justifyContent: "space-around",
                            marginRight: "73px"
                          }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            City:{cityState.label}
                          </span>{" "}
                          <span style={{ fontSize: "14px" }}>
                            Area:{areaState.label}
                          </span>
                          <span>
                            <div className="right-cont-outer">
                              <div className="left-cls" style={{ color: "#163e8c", alignItems: "left", fontSize: "14px" }}><b>EDIT</b></div>
                            </div>
                          </span>
                        </div>
                      ) : (
                        <div
                          className="location"
                          onClick={() => setShowLocation(true)}
                        >
                          Search and set your location
                          <img src={dropdown1} alt="icon" />
                        </div>
                      )}
                    </div>


                  </div>
                </div>


              )}
            </div>


            <div className="Card_container_list">
              <div className="pathologyCardList">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "wrap",
                    width: "100%",
                    gap: "12px",

                  }}
                >
                  {
                    <Grid container spacing={4}>
                      {packages.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <PackageCard _package={item} />
                        </Grid>
                      ))}
                    </Grid>
                  }
                </div>

                <div className="pagination_container">
                  {
                    <div className="page_container">
                      <Button
                        disabled={pageno === 1}
                        style={{ color: "white", backgroundColor: "#0b46ab" }}
                        onClick={() => handleCount1(-1)}
                      >
                        <img src={left} alt="icon" />
                      </Button>
                      <Typography
                        variant="body"
                        style={{ lineHeight: "20px", marginTop: "8px" }}
                      >
                        Page <span style={{ color: "orange" }}>{pageno + 1}</span>{" "}
                        of{` ${packagesCount === 0 ? Math.ceil(1) : Math.ceil(packagesCount / 9)}`}
                      </Typography>
                      <Button
                        disabled={pageno === Math.ceil(packagesCount / 8)}
                        style={{ color: "white", backgroundColor: "#0b46ab" }}
                        onClick={() => handleCount1(1)}
                      >
                        <img src={right} alt="icon" />
                      </Button>
                    </div>
                  }
                </div>
              </div>

              {/* {(!mobileView && (
                                <CardSelectedTest
                                    type="popular_test"
                                    list={selectedRec}
                                    // del={delSelectedTest}
                                    // featuredel={handlleRemoveTest}
                                    area={area}
                                // handleLocPop={handleLocPop}
                                />
                            )) ||
                                ""} */}
            </div>

            <div className="input_containerrr" ref={focusPoint}>
              <div className="leftContainer">
                {searchData && searchData.length > 0 && (
                  <div className="heading_container">
                    <div className="heading">Search Result</div>
                    <div className="txt">Browse through searched tests</div>
                  </div>
                )}
              </div>
            </div>

            <div className="Card_container_list">
              <div className="pathologyCardList">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "wrap",
                    width: "100%",
                    gap: "12px",

                  }}
                >
                  {searchData && searchData.length !== 0
                    ? searchData.map((value, i) => (
                      <CardSelectTest
                        index={i}
                        key={i}
                        val={value}
                        heading={value.doc.standardisedtestname}
                        subHeading={value.doc.partnerstestname}
                        des={value.doc.populartestdescription}
                      // handleItems={selectTest}
                      // handleItemDelete={delSelectedTest}
                      />
                    ))
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        {!mobileView && (
          <div className="container_work">
            <div className="heading">How it works?</div>
            <div className="text">Get your medical tests in 3-simple steps</div>
            <Card />
          </div>
        )}
        <SliderComponent />
        {!mobileView && (
          <div className="trustpar">
            <div className="by">
              OUR PARTNERS
            </div>
            <PartnerSlider partner={partner} />
          </div>
        )}
        <Sheet
          isOpen={btmSheet}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <MobileCardSelectedTest
                // type="landing"
                onClose={() => {
                  setbtmSheet(false);
                }}
                list={selectedRec}
                // del={delSelectedTest}
                // featuredel={handlleRemoveTest}
                area={area}
              />
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>

        <Sheet
          isOpen={btmLocationSheet}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmLocationSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <Popup
                city={city}
                setShowLocation={() => {
                  setbtmLocationSheet(false);
                  setbtmSheet(true);
                }}
                setArea={setArea}
                setSelectedRec={setSelectedRec}
              />{" "}
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>

        {mobileView && (
          <FloatingIcon
            onClick={() => {
              area.length === 0 ? setbtmLocationSheet(true) : setbtmSheet(true);
            }}
            count={selectedRec.length + lanTestes.data.length}
          />
        )}
        <Modal show={ShowArea} onHide={console.log("area hide")}>
          <Filter />
        </Modal>

        <Modal show={ShowLocation} onHide={console.log("location close")}>
          <Popup
            city={city}
            setShowLocation={setShowLocation}
            setArea={setArea}
            setSelectedRec={setSelectedRec}
          />
        </Modal>

        <Modal
          show={mobileTestpopstate}
          onHide={console.log("mobileTestpopstate")}
        >
          <Popup
            city={city}
            setShowLocation={setShowLocation}
            setArea={setArea}
          />
        </Modal>

        {/* <Chat /> */}
      </Layout>
      <Toast
        text={toastMessage}
        type="error"
        open={toastOpen}
        setClose={() => {
          setToastOpen(false);
        }}
      />
      {loading && <LoaderComponent />}
    </div>
  );
};

const FloatingIcon = (props) => {
  console.log(props, "18vkjnlk");
  return (
    <div className="floatingIcon" onClick={() => props.onClick()}>
      <div className="count">{props.count}</div>
      <img alt="icon" src={ficon} />
      {(props.count === 0 && <div className="foverlay"></div>) || ""}
    </div>
  );
};

export default PopularPackages;
